import { Reducer } from 'redux'; 
import * as types from './types';
import { ArcadeRoomsState } from './interfaces';
import produce from 'immer';

const arcadeRoomsState: ArcadeRoomsState = {
    room: {
        id: undefined,
        name: '',
        freePlay: false,
        cabinets: []
    },
    rooms: [],
    cabinetOptions: []
};

const setRooms = produce((draft, action) => {
    draft.rooms = action.rooms;
});
const setRoom = produce((draft, action) => {
    const { success, ...room } = action.room;
    draft.room = room;
});
const setReorderedCabinets = produce((draft, action) => {
    draft.room.cabinets = action.cabinets;
});
const clearRoom = produce(draft => {
    draft.room = arcadeRoomsState.room;
});
const addCabinetToRoom = produce((draft, action) => {
    draft.room.cabinets.push(action.cabinet);
});
const setRoomValue = produce((draft, action) => {
    draft.room[ action.name ] = action.value;
});

export const roomsReducer: Reducer<ArcadeRoomsState> = (state = arcadeRoomsState, action) => {
    switch (action.type) {
        case types.ARCADE_ROOM__SET_ROOMS:
            return setRooms(state, action);
        case types.ARCADE_ROOM__SET_ROOM:
            return setRoom(state, action);
        case types.ARCADE_ROOM__CLEAR_ROOM:
            return clearRoom(state);
        case types.ARCADE_ROOM__SET_REORDERED_CABINETS:
            return setReorderedCabinets(state, action);
        case types.ARCADE_ROOM__ADD_CABINET_TO_ROOM:
            return addCabinetToRoom(state, action);
        case types.ARCADE_ROOM__SET_ROOM_VALUE:
            return setRoomValue(state, action);
        case types.ARCADE_ROOM__CLEAR_ROOMS:
            return arcadeRoomsState;
        default:
            return state;
    }
};
